<script>
import {DateUtil} from '@/utils/date.js'
import shiftDetailComponent from '@/components/shiftDetailComponent'
import MainLayout from '@/router/layouts/mainLayout'
import dialog from '@/components/Dialog'
export default {
  components: {
    shiftDetailComponent, MainLayout, 'v-dialog': dialog
  },
  data () {
    return {
      moveShiftTime: '',
      businessStatus: 0,
      shiftMovementFlag: false,
      shiftId: '',
      eventId1: '',
      dialogOption: {
        showNo: true,
        text: 'このイベントを削除してもよろしいですか？',
        cancelButtonText: 'いいえ',
        confirmButtonText: 'はい'
      },
      dialogOptionOfShift: {
        showNo: true,
        text: 'この便を取り消してもよろしいですか？<br/>(登録されているルートは削除されません)',
        cancelButtonText: 'いいえ',
        confirmButtonText: 'はい'
      },
      showDialog: '',
      showDialogOfShift: '',
      backName: ((this.$route.query.from === 'MovementShift' || this.$route.query.from === 'VehicleList' || this.$route.query.from === 'ShiftEditor')
        ? '運行便に戻る' : ((this.$route.query.from === 'MovementStatus') ? '運行状況一覧に戻る' : '運行状況に戻る')),
      transportKind: 0,
      allConnectShiftsCanEdit: true,
    }
  },
  created() {
    console.log("created")
    this.transportKind = this.$route.query.transportKind
    this.allConnectShiftsCanEdit = this.$route.query.allConnectShiftsCanEdit
    if(this.allConnectShiftsCanEdit != null){
      if(typeof this.allConnectShiftsCanEdit === "string" || this.allConnectShiftsCanEdit instanceof String){
      }else{
        this.allConnectShiftsCanEdit = this.allConnectShiftsCanEdit.toString()
      }
    }
    console.log(this.transportKind)
    console.log(this.allConnectShiftsCanEdit)
  },
  methods: {
    cancel (val1, val2) {
      this.showDialogOfShift = true
      this.$refs.dialogOfShift.confirm().then(() => {
        this.$axios.get('shift/deleteRelatedInfoOfShift', {params: {shiftId: val1, eventId: val2}})
          .then(response => {
            if (this.$route.query.from === 'MovementStatus') {
              this.$router.go(-1)
            } else {
              // 返回到运行便一览画面的开始选择的月份
              this.$router.push({path: '/MovementShift', query: {currentDate: DateUtil.getYearMonthDay(this.moveShiftTime).substr(0, 6)}})
            }
          })
          .catch((error) => {
            console.log(error)
          })
        this.showDialogOfShift = false
      }).catch(() => {
        this.showDialogOfShift = false
      })
    },
    getShiftId (val, flag, status, eventId, moveShiftTime) {
      this.shiftId = val
      this.shiftMovementFlag = flag
      this.businessStatus = status
      this.eventId1 = eventId
      this.moveShiftTime = moveShiftTime
    },
    eventEdit () {
      this.$router.push({ path: '/EventGenerate' })
    },
    eventDelete (val) {
      this.showDialog = true
      let param = this.$qs.stringify({
        eventId: val
      })
      this.$refs.dialog.confirm().then(() => {
        this.$axios.post('shift/deleteShiftEventById', param)
          .then(response => {
            let aaa = JSON.parse(sessionStorage.getItem('shiftDetail'))
            aaa.shiftInfo.eventId = null
            aaa.shiftInfo.shiftType = '1'
            sessionStorage.setItem('shiftDetail', JSON.stringify(aaa))
            sessionStorage.removeItem('shiftEventInfo')
            location.reload()
          })
          .catch(function (error) {
            console.log(error)
          })
        this.showDialog = false
      }).catch(() => {
        this.showDialog = false
      })
    },
    shiftEdit () {
      this.$router.push({ path: '/ShiftEditor' })
    }
  }
}
</script>
<template>
<main-layout>
      <shift-detail-component
        :backName="backName"
        :rightTopBtnName="'運行表出力'"
        :mapBtnVisibility= true
        @transShiftId="getShiftId">
      </shift-detail-component>
    <div class="col-md-12 column" style="margin-top:10px; margin-bottom:10px;">
        <div v-if="shiftMovementFlag && businessStatus === 1 && allConnectShiftsCanEdit == 'true'">
          <div style="margin:0 auto; width:25%" v-if="transportKind != 1">
            <button class="window-button-percent F2-M-24" @click="cancel(shiftId,eventId1)">この便を取り消す</button>
          </div>
        </div>
        <div v-else-if="(eventId1 === null || eventId1 ==='') && !shiftMovementFlag && businessStatus === 1 && allConnectShiftsCanEdit == 'true'" style="display: 100%;">
          <div class="" style="margin: auto;">
            <button class="window-button-percent F2-M-24" style="width: 400px; margin-right: 10px;" @click="shiftEdit">編集</button>
            <button class="window-button-percent F2-M-24" style="width: 400px; margin-left: 10px;" v-if="transportKind != 1" @click="cancel(shiftId,eventId1)">この便を取り消す</button>
          </div>
        </div>
        <div v-else-if="(eventId1 !== null && eventId1.length !== 0) && !shiftMovementFlag && businessStatus === 1 && allConnectShiftsCanEdit == 'true'">
          <div class="" style="margin: auto;">
            <button class="window-button-percent F2-M-24" style="width: 22%; margin:5px 5px;" @click="shiftEdit">編集</button>
            <button class="window-button-percent F2-M-24" style="width: 22%; margin:5px 5px;" @click="eventEdit">イベントを編集</button>
            <button  class="window-button-percent F2-M-24" style="width: 22%; margin:5px 5px;" @click="eventDelete(eventId1)">イべントを削除</button>
            <button class="window-button-percent F2-M-24" style="width: 22%; margin:5px 5px;" v-if="transportKind != 1" @click="cancel(shiftId,eventId1)">この便を取り消す</button>
          </div>
        </div>
        <div v-else> </div>
          <v-dialog v-show="showDialog" :dialog-option="dialogOption" ref="dialog"></v-dialog>
          <v-dialog v-show="showDialogOfShift" :dialog-option="dialogOptionOfShift" ref="dialogOfShift"></v-dialog>
    </div>
</main-layout>
</template>
<style lang="css" scoped>
.window-button-percent{
  width: 100%;
  height: 50px;
  border-radius: 10px;
  border: none;
  font-size: 20px;
  color:#fff;
  background:linear-gradient(rgb(112, 182, 202) 50%, rgb(72,163,190) 50%);
  }
</style>



// WEBPACK FOOTER //
// src/router/views/ShiftWithEventDetail.vue